import React, { Component } from 'react';
import dateTimeHelper from '../../Helpers/datetimeHelper';
import TimeSheetEntryService from '../../Services/timeSheetEntryService';
import ErrorMessage from '../../Elements/ErrorMessage';
import mathHelper from '../../Helpers/mathHelper';
import FaIcon from '../../Elements/FaIcon';
import TimesheetHelper from '../../Helpers/ModelHelpers/TimesheetHelper';

export default class UsageRate extends Component {
  static defaultProps = {
    userId: 0,
    selectedDate: new Date(),
    bookedMinutes: 0,
    entryList: [], //this is needed because we want to recalculate the data when the entry list changes
    rate: -1,
    numberOfEntries: 0,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.populateUsageRateData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.populateUsageRateData();
    }
  }

  populateUsageRateData() {
    const bookedMinutes = this.calculateBookedMinutes();
    TimeSheetEntryService.GetWeeklyWorkingMinutes(this.props.userId, this.props.selectedDate)
      .then((response) => {
        this.setState({
          usageRate:
            response.data > 0
              ? `${dateTimeHelper.convertMinutesToTimeHM(bookedMinutes)} / ${dateTimeHelper.convertMinutesToTimeHM(
                  response.data
                )} (${mathHelper.PercentageText(bookedMinutes, response.data)})`
              : dateTimeHelper.convertMinutesToTimeHM(bookedMinutes),
          rate: response.data > 0 ? bookedMinutes / response.data : -1,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('UR37'));
  }

  calculateBookedMinutes() {
    let bookedMinutes = 0;
    let numberOfEntries = 0;
    const weekStart = dateTimeHelper.startOfTheDay(this.props.selectedDate);
    const weekEnd = dateTimeHelper.addDaysToDate(weekStart, 7);

    // GetDistinctEntries drops the extra display row that an entry crossing midnight adds to
    // the list — both rows carry the same full span, so they used to be booked twice. The week
    // window is half-open [weekStart, weekEnd) so an entry starting at Monday 00:00 counts.
    TimesheetHelper.GetDistinctEntries(this.props.entryList).forEach((entry) => {
      const entryStart = TimesheetHelper.GetEntryDateTime(entry.startDate, entry.startTime);
      if (!entryStart || entryStart < weekStart || entryStart >= weekEnd) return;

      bookedMinutes += TimesheetHelper.GetEntryDurationInMinutes(entry);
      numberOfEntries++;
    });

    this.setState({ numberOfEntries });

    return bookedMinutes;
  }

  render() {
    return (
      <div>
        {`${this.state.usageRate} `}
        {this.state.rate >= 0 ? (
          <FaIcon
            innerClassName={
              this.state.rate < 0.5 ? 'text-danger' : this.state.rate < 0.8 ? 'text-warning' : 'text-success'
            }
          />
        ) : null}
        {` ${this.state.numberOfEntries}`}
      </div>
    );
  }
}
